import { render } from "./BitAssistWidget.vue?vue&type=template&id=7f433a4e&scoped=true"
import script from "./BitAssistWidget.vue?vue&type=script&lang=js"
export * from "./BitAssistWidget.vue?vue&type=script&lang=js"

import "./BitAssistWidget.vue?vue&type=style&index=0&id=7f433a4e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f433a4e"]])

export default __exports__